import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { catalogRecencyTextV1021 } from './catalogRecencyV1021';
import './catalogRecencyV1021.css';
import './modelSiteOriginsV1024.css';

export default function ModelSiteOriginsV1024({
  item,
  root,
  language,
  inline = false,
}) {
  if (!root) return null;
  const zh = language?.startsWith('zh');
  const title = zh ? '站点来源（渠道）' : 'Site origins (channels)';
  const statuses = catalogRecencyTextV1021(language);
  const origins = item.site_origins_v1024;
  // The existing Root price-gap inventory uses the earlier allowlisted DTO.
  const channels =
    origins?.state === 'ready' && Array.isArray(origins.channels)
      ? origins.channels
      : !origins && Array.isArray(item.registered_channels_v1021)
      ? item.registered_channels_v1021
      : null;
  const unavailable = zh
    ? '来源暂时无法加载'
    : 'Origins temporarily unavailable';
  const empty = zh ? '暂无已登记站点来源' : 'No registered site origins';
  const content = channels?.length ? (
    <ul className='model-channels-list-v1021'>
      {channels.map((channel) => (
        <li key={channel.id}>
          <strong>{channel.name || `#${channel.id}`}</strong>
          <span>
            #{channel.id} /{' '}
            {channel.status === 1
              ? statuses.enabled
              : channel.status === 2
              ? statuses.manual
              : channel.status === 3
              ? statuses.automatic
              : statuses.unknown}
          </span>
        </li>
      ))}
    </ul>
  ) : (
    <span role={channels === null ? 'status' : undefined}>
      {channels === null ? unavailable : empty}
    </span>
  );
  if (inline)
    return (
      <section className='model-site-origins-detail-v1024' aria-label={title}>
        <h4>{title}</h4>
        {content}
      </section>
    );
  const label =
    channels === null
      ? `${title}: ${unavailable}`
      : `${title}: ${channels.length}`;
  return (
    <div className='model-site-origins-v1024'>
      <Popup
        on={['hover', 'focus', 'click']}
        closeOnTriggerClick={false}
        hoverable
        position='top left'
        className='model-channels-popup-v1021'
        trigger={
          <button
            type='button'
            className='model-channels-trigger-v1021 model-site-origins-trigger-v1024'
            aria-label={label}
          >
            <Icon name='sitemap' aria-hidden='true' />
            <span>{label}</span>
          </button>
        }
        content={
          <div role='tooltip' aria-label={title}>
            {content}
          </div>
        }
      />
    </div>
  );
}
